/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_About_VersionInputs */

const en_ui_settings_about_version = /** @type {(inputs: Ui_Settings_About_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const de_ui_settings_about_version = /** @type {(inputs: Ui_Settings_About_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

/**
* | output |
* | --- |
* | "Build" |
*
* @param {Ui_Settings_About_VersionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_about_version = /** @type {((inputs?: Ui_Settings_About_VersionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_About_VersionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_about_version(inputs)
	return de_ui_settings_about_version(inputs)
});